import PaymentMethodDetails from './PaymentMethodDetails';

import { ICreditCardForm, IPaymentMethodsList } from '@interfaces/myProfileInterfaces';

import { getLabelFallback } from '@utils/utils';

interface Props {
    paymentMethods: IPaymentMethodsList;
    showAddCreditCardForm: (showForm: boolean) => void;
    hideButton: boolean;
}

const PaymentMethodsList = ({
    paymentMethods,
    showAddCreditCardForm,
    hideButton = false,
}: Props): JSX.Element => {
    return (
        <div className="payment-methods_list">
            <div className="container">
                {paymentMethods.payments.map((paymentMethod, index) => (
                    <PaymentMethodDetails
                        key={index}
                        paymentMethodDetails={paymentMethod}
                        index={index}
                        defaultPaymentMethod={paymentMethods.defaultPayment}
                    />
                ))}
            </div>
            <div>
                {!hideButton && (
                    <button
                        role="region"
                        aria-label="add payment method button"
                        data-element-id="PaymentMethods_AddNew"
                        className="primary-button button-size-medium"
                        onClick={() => showAddCreditCardForm(true)}
                    >
                        {getLabelFallback('PAYMENT_METHODS_ADD_CTA_LABEL')}
                    </button>
                )}
            </div>
        </div>
    );
};

export default PaymentMethodsList;
